/**
 * Requires
 */

import $ from 'jquery'

let offset = 0
let openState = false
//     let value = $(`[data-tickets-options] option[data-tickets-id=${ticketRef}]`).val()
/**
 * Initialisation
 */

export function initialise() {
  $('[data-tickets-cell]').on('click', function() {
    const ticketRef = $(this).data('tickets-cell')
    if (ticketRef) {
      $(`[data-tickets-options] option[data-tickets-id]`).attr('selected', false)
      let selected = $(`[data-tickets-options] option[data-tickets-id=${ticketRef}]`)
        .attr('selected', 'selected')
        .val()
      $('[data-tickets-url]').attr('href', selected)
      let ticketStatus = $(`[data-tickets-options] option[data-tickets-id=${ticketRef}]`).data('ticket-status')
      updateStatus(ticketStatus)
    }
  })

  updateOverviewHeight()

  $('[data-tickets-options]').on('change', function() {
    let ticketStatus = $(this)
      .find(':selected')
      .data('ticket-status')
    updateStatus(ticketStatus)
  })

  $('[data-tickets-options]').on('change', function() {
    $('[data-tickets-url]').attr('href', this.value)
  })

  $('[data-tickets-options]').trigger('change')

  if ($('[data-summary-tickets]').length) {
    const $toggle = $('[data-summary-tickets]')
    const $toggleTarget = $('[shows-sticky-footer]')
    const elementOffset = $toggle.offset()
    $(window).on('scroll', function() {
      offset = $(document).scrollTop()
      let height = $(document).height()
      let atBottom = offset + +$(window).height() === height
      if (elementOffset.top < offset && !openState) {
        $toggleTarget.addClass('open')
        openState = true
      } else if ((elementOffset.top > offset || atBottom) && openState) {
        $toggleTarget.removeClass('open')
        openState = false
      }
    })
  }
}

function updateStatus(ticketStatus) {
  if (ticketStatus == 'limited') {
    ticketStatus = 'Limited Tickets'
  } else if (ticketStatus == 'soldout') {
    ticketStatus = 'Allocation Exhausted'
  }
  $('[data-tickets-url]').text(ticketStatus)
}

function updateOverviewHeight() {
  setTimeout(function() {
    const $showAccordion = $('[data-toggle-target="show-overview"]')
    const showOverviewHeight = $('[data-toggle-target="show-overview"] [data-accordion-wrapper]').height()
    $('[data-toggle="show-overview"]').on('click', function() {
      $showAccordion.css('max-height', `${showOverviewHeight}px`)
    })
  }, 200)
}
